/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { mobileOrderItemGroupUnionModifierCreateSchema } from "./mobileOrderItemGroupUnionModifierCreateSchema.ts";
import { mobileOrderItemModifierCreateSchema } from "./mobileOrderItemModifierCreateSchema.ts";

export const mobileOrderItemCreateSchema = z.object({
	id: z.uuid(),
	amount: z.int().min(1),
	size: z.uuid().nullish(),
	comment: z.string().max(120).nullish(),
	modifiers: z.array(mobileOrderItemModifierCreateSchema).nullish(),
	group_modifiers: z.array(mobileOrderItemGroupUnionModifierCreateSchema).nullish(),
	front_item_id: z.uuid().nullish(),
	marking_code: z.string().nullish(),
});
